export default __webpack_public_path__ + "static/media/slide.3fa575cf.jpg";